import type { HintKey } from 'constants/hints';
import { HINT_META_DATA, USER_HINTS } from 'constants/hints';
import { getUser, getUserProperties } from 'redux/selectors/user';
import { createSelector } from 'reselect';
import type { HintMeta, HintsToShow } from 'types/hint';
import { shouldShowHint } from 'utils/hints';

const readHints = (): Array<HintKey> => USER_HINTS;
const readHintMetaData = (): Partial<HintMeta> => HINT_META_DATA;

/**
 * didUserSignupAfterHintsReleased
 *
 * Jacqueline: Is there any way we can just show the hints to the
 *   users who signed up from June 28th onwards (release date)?
 * Graeme: yah, that sounds like a good one.
 *
 */
const didUserSignupAfterHintsReleased = createSelector([getUser], (user): boolean => {
  const signedUp = user.created_at;
  /**  Release date unix: new Date('July 28, 2019').getTime() / 1000 = 1564297200 */
  const releaseDate = 1564297200;
  return signedUp > releaseDate;
});

export const getHints = createSelector(
  [getUserProperties, readHints, readHintMetaData, didUserSignupAfterHintsReleased],
  (userProperties, hints, hintMeta, didSignupAfterThreshold): HintsToShow => {
    const showHints: HintsToShow = {};
    if (!didSignupAfterThreshold) {
      return showHints;
    }
    hints.forEach((current: HintKey) => {
      showHints[current] = shouldShowHint(current, userProperties, hintMeta);
    });

    return showHints;
  }
);
